export const statusMixin = {
    data() {
        return {
            fail: false
        }

    },
    methods: {
        dispatchPaymentStatus(status) {
            window.dispatchEvent(new CustomEvent('payment-status', {
                detail: {
                    status: status,
                    ref: this.ref
                }
            }));
        },
    },
    mounted() {
        setTimeout(() => this.dispatchPaymentStatus(!this.fail), 500)
    }
}
